module.exports = __webpack_public_path__ + "img/IRES_Portal_sRGB.d6aacb2f.png";